module.exports = __webpack_public_path__ + "media/svg-new/form 2-2db7e91b.svg";